import { Components } from '@mui/material/styles';

const muiDialogStyles: Components = {
  MuiDialog: {
    defaultProps: {
      slotProps: {
        backdrop: {
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.30)' }
        }
      }
    },
    styleOverrides: {
      root: {},
      paper: {
        padding: '50px 38px',
        maxHeight: '94vh !important',
        '@media (max-width: 1715px)': {
          padding: '38px 24px'
        }
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: '22px',
        color: 'var(--dark-2)',
        fontWeight: 600,
        padding: '0 0 16px 0',
        '@media (max-width: 1715px)': {
          fontSize: '18px !important',
          padding: '0 0 8px 0'
        }
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: { padding: '16px 0 0 0' }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: { padding: '8px 0' }
    }
  }
};

export default muiDialogStyles;
